var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"individual-progress-bar-step-item",attrs:{"data-is-active":_vm.isActive}},[_c('img',{attrs:{"width":"12px","height":"12px","loading":"lazy","decoding":"async","src":_vm.imageSrc,"alt":_vm.alt}}),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }